import { Injectable } from '@angular/core';
import { AuthService, IUserInfo } from '../api/auth.service';
import { RoutesService } from '../api/routes.service';
import { BehaviorSubject } from 'rxjs';
import { IInstitution } from '../api/models/db/institutions.schema';

export interface IInstitutionInfo {
  id?          : number,
  name?        : string,
  address?     : string,
  city?        : string,
  province?    : string,
  postalCode? : string,
  phoneNumber?: string,
  faxNumber?  : string,
  contactEmail?  : string, // this always starts blank... inst managers need to put this in place themselves.
  isShown?    : boolean,
}
@Injectable({
  providedIn: 'root'
})
export class MyInstitutionService {

  private info: BehaviorSubject<IInstitutionInfo> = new BehaviorSubject(null);

  constructor(
    private auth: AuthService,
    private routes: RoutesService,
  ) { 
    this.auth.user().subscribe(this.updateUserInfo)
  }

  private updateUserInfo = (userInfo:IUserInfo) => {
    if (userInfo){
      const institutionId = userInfo.accountInfo.institutionId;
      this.auth
        .apiGet(this.routes.TEST_ADMIN_INSTITUTION, institutionId)
        .then( (institutionRecord:IInstitution) => {
          this.info.next({
            id: institutionRecord.id,
            name: institutionRecord.name,
            address: institutionRecord.address,
            city: institutionRecord.city,
            province: institutionRecord.province,
            postalCode: institutionRecord.postal_code,
            phoneNumber: institutionRecord.phone_number,
            faxNumber: institutionRecord.fax_number,
            isShown: !!institutionRecord.is_shown,
          });
        })
    }
    else{
      this.info.next(null);
    }
  }

  sub(){
    return this.info;
  }


}
